import React, { useState, Component } from 'react'
import { AuthContext } from '../context/AuthContext'
import styled from 'styled-components'
import { IoLogoOctocat } from 'react-icons/io'

class GitHubLogin extends Component {
  static contextType = AuthContext
  render() {
    const { loginAction } = this.context
    const { logoutAction } = this.context
    const isAuthenticated = this.context.isAuthenticated
    return (
      <AuthContext.Consumer>
        {context => {
          return (
            <section>
              {/* <div>Is this going to show up: {number}</div> */}
              {/* {authenticatedWithGitHub && <div>Shows up if true or false</div>} */}
              {/* <GitHubLogin /> */}
              {/* <button onClick={isLoggedInFunction}>click here</button> */}
              <Wrapper>
                {!isAuthenticated && (
                  <button onClick={loginAction} class="btn-flex">
                    <IoLogoOctocat className="octocat" />
                    <p>Login with GitHub</p>
                  </button>
                )}
                {isAuthenticated && (
                  <button onClick={logoutAction}>Logout</button>
                )}
              </Wrapper>
            </section>
          )
        }}
      </AuthContext.Consumer>
    )
  }
}

const Wrapper = styled.div`
  .btn-flex {
    display: flex;
  }
  .octocat {
    /* size: 48px; */
    font-size: 20px;
  }
  button {
    background: black;
    color: white;
    height: 40px;
    border-radius: 23px;
    padding: 0 9px;
    padding-top: 9px;
    margin-left: 3px;
  }
  p {
    margin-left: 3px;
    color: white;
    font-size: 16px;
  }
`

export default GitHubLogin
